"use client";

import { Spinner } from "@/components/ui/Spinner";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

// Next.js 16 App Router の RSC redirect() バグ（vercel/next.js#63121）を回避するため、
// サーバで解決したURLにクライアント側で replace 遷移する
export const MedicalCheckupsIndexRedirect = ({
  redirectUrl,
}: {
  redirectUrl: string;
}) => {
  const router = useRouter();

  useEffect(() => {
    router.replace(redirectUrl);
  }, [router, redirectUrl]);

  return (
    <div className="flex h-full w-full items-center justify-center py-20">
      <Spinner size="lg" />
    </div>
  );
};
